<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			width="90%"
			:max-width="1200"
			:min-width="1000"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon class="mr-2">mdi-book-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Detalle Presupuesto</p>
						</div>
						<div class="d-flex align-center">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										outlined
										dark
										small
										color="#959595"
										class="mr-2"
										@click="toFullView"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small class="mr-2">mdi-book-outline</v-icon>
										<p class="mb-0 caption">Ir a Vista Completa</p>
									</v-btn>
								</template>
								<span>Cerrar</span>
							</v-tooltip>
							<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
								<v-icon dark>mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
					<BudgetDetailComponent :budgetId="$store.state.budget.budgetComponentModalId" />
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import BudgetDetailComponent from '@/components/Views/Budgets/BudgetDetailComponent'

export default {
  name: 'BudgetComponentModal',
  components: { BudgetDetailComponent },
  data: () => ({
		indexModal: + new Date(),
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
    closeModal(){
      this.$store.commit('budget/setBudgetComponentModalId', null)
    },
		toFullView(){
			this.$router.push({ name: 'BudgetDetail', query: { id: this.$store.state.budget.budgetComponentModalId } })
			this.closeModal()
		},
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>